import { UploadEntity } from "moh-package";

export class SrvDeceased {

  FirstName: string;
  LastName: string;
  IDNumber: string;
  FathersName: string;
  DateOfDeath: Date;
  PlaceOfDeath: string;
  DeathNoticeDocument: UploadEntity;
  DeathCertificateDocument: UploadEntity;

  constructor(data: SrvDeceased) {

    Object.assign(this, data);

    if (data) {

    
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/Survivors/SrvDeceased.ts